import styled from 'styled-components'

export const Icon = styled.i`
    font-size: 14px;
    margin-right: 16px;
`